/**
 * Exemplos fictícios da documentação — não são dados do TEG.
 *
 * Só alimentam as amostras de componente em /admin/design-system, para o
 * componente real ter o que mostrar. Determinísticos (nunca aleatórios), sem
 * nome de pessoa ou empresa real, sem CPF de verdade (só zeros, para mostrar
 * o formato) e sem mês literal: a documentação
 * não pode envelhecer nem parecer um registro de verdade.
 */
import type { StatusVariant } from '@/ui/StatusBadge';

/** CPF de pessoa nunca aparece por inteiro, nem em exemplo; a amostra de máscara usa só zeros. */
export const CPF_MASCARADO = '***.***.***-**';

/**
 * Valores só de zeros e de domínio reservado, para as amostras de máscara e
 * cópia: mostram o formato e não são de ninguém (`.invalid` não existe).
 */
export const FORMATOS_DE_EXEMPLO = {
  cpf: '00000000000',
  cnpj: '00000000000000',
  telefone: '11900000000',
  placa: 'ABC1D23',
  email: 'pessoa.exemplo@exemplo.invalid',
  protocolo: 'SEI-0000.0000/0000000-0',
} as const;

export const OS_DE_EXEMPLO = {
  numero: 'OS 000482',
  condutor: 'Pessoa Exemplo Um',
  monitor: 'Pessoa Exemplo Dois',
  placa: 'ABC-1D23',
  status: 'VIGENTE' as const,
};

export const INDICADORES_DE_EXEMPLO = [
  { label: 'Credenciados ativos', value: '1.284', hint: '+3,2% em relação ao mês anterior' },
  { label: 'Ordens de Serviço vigentes', value: '915', hint: '13 DREs' },
  { label: 'Apontamentos pendentes', value: '37', hint: 'Prazo de 5 dias úteis' },
  { label: 'Valor apurado', value: 'R$ 4.812.930,00', hint: 'Mês anterior' },
];

export interface CredenciadoDeExemplo {
  id: string;
  nome: string;
  cpf: string;
  dre: string;
  status: StatusVariant;
}

export const CREDENCIADOS_DE_EXEMPLO: CredenciadoDeExemplo[] = [
  { id: '1', nome: 'Pessoa Exemplo Um', cpf: CPF_MASCARADO, dre: 'Campo Limpo', status: 'ativo' },
  { id: '2', nome: 'Pessoa Exemplo Dois', cpf: CPF_MASCARADO, dre: 'Butantã', status: 'pendente' },
  {
    id: '3',
    nome: 'Pessoa Exemplo Três',
    cpf: CPF_MASCARADO,
    dre: 'Ipiranga',
    status: 'bloqueado',
  },
  {
    id: '4',
    nome: 'Pessoa Exemplo Quatro',
    cpf: CPF_MASCARADO,
    dre: 'São Mateus',
    status: 'ativo',
  },
];
